import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import {
  createVaultCategory,
  updateVaultCategory,
  deleteVaultCategory,
} from '../../data';
import { useNotification } from '../../../../shared/Notification/useNotification';

const useInvalidateCategories = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries(['vaultCategories']);
    queryClient.invalidateQueries(['vaultFiles']);
  };
};

export const useCreateVaultCategoryMutation = () => {
  const { t } = useTranslation('vault');
  const { showSuccess, showError } = useNotification();
  const invalidateQueries = useInvalidateCategories();

  const {
    mutateAsync: createCategoryMutation,
    isLoading: isCreating,
  } = useMutation(createVaultCategory, {
    onSuccess: () => {
      showSuccess({ content: t('categoryCreated') });
      invalidateQueries();
    },
    onError: () => {
      showError({ content: t('categoryCreateFailed') });
    },
  });

  return { createCategoryMutation, isCreating };
};

export const useUpdateVaultCategoryMutation = () => {
  const { t } = useTranslation('vault');
  const { showSuccess, showError } = useNotification();
  const invalidateQueries = useInvalidateCategories();

  const {
    mutateAsync: updateCategoryMutation,
    isLoading: isUpdating,
  } = useMutation(updateVaultCategory, {
    onSuccess: () => {
      showSuccess({ content: t('categoryUpdated') });
      invalidateQueries();
    },
    onError: () => {
      showError({ content: t('categoryUpdateFailed') });
    },
  });

  return { updateCategoryMutation, isUpdating };
};

export const useDeleteVaultCategoryMutation = () => {
  const { t } = useTranslation('vault');
  const { showSuccess, showError } = useNotification();
  const invalidateQueries = useInvalidateCategories();

  const {
    mutateAsync: deleteCategoryMutation,
    isLoading: isDeleting,
  } = useMutation(deleteVaultCategory, {
    onSuccess: () => {
      showSuccess({ content: t('categoryDeleted') });
      invalidateQueries();
    },
    onError: () => {
      showError({ content: t('categoryDeleteFailed') });
    },
  });

  return { deleteCategoryMutation, isDeleting };
};
